<div class="modal-backdrop" *ngIf="showModal" (click)="close()"></div>

<div class="modal-container" *ngIf="showModal">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="modal-header">
      <div class="modal-title">
        <i class="fas fa-tools"></i>
        <h2>Selecionar Mecânico</h2>
      </div>
      <button class="btn-close" (click)="close()" type="button">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <!-- Search Bar -->
    <div class="modal-search">
      <div class="search-input-container">
        <i class="fas fa-search search-icon"></i>
        <input 
          type="text" 
          class="search-input" 
          [(ngModel)]="searchTerm"
          (input)="onSearch()"
          placeholder="Buscar por nome, cargo, especialidade, telefone ou email..."
          autofocus>
      </div>
    </div>

    <!-- Mechanic List -->
    <div class="modal-body">
      <!-- Loading -->
      <div class="loading-container" *ngIf="isLoading">
        <i class="fas fa-spinner fa-spin"></i>
        <p>Carregando funcionários...</p>
      </div>

      <div class="mechanics-list" *ngIf="!isLoading">
        <div 
          *ngFor="let mechanic of filteredMechanics"
          class="mechanic-item"
          [class.selected]="selectedMechanic?.id === mechanic.id"
          (click)="selectMechanic(mechanic)">
          <div class="mechanic-icon">
            <i class="fas fa-user-cog"></i>
          </div>
          <div class="mechanic-info">
            <div class="mechanic-name">{{ mechanic.nome }}</div>
            <div class="mechanic-details">
              <span><i class="fas fa-briefcase"></i> {{ mechanic.cargo }}</span>
              <span><i class="fas fa-cog"></i> {{ mechanic.especialidade }}</span>
            </div>
            <div class="mechanic-contact">
              <span><i class="fas fa-phone"></i> {{ mechanic.telefone }}</span>
              <span><i class="fas fa-envelope"></i> {{ mechanic.email }}</span>
            </div>
          </div>
          <div class="mechanic-check" *ngIf="selectedMechanic?.id === mechanic.id">
            <i class="fas fa-check-circle"></i>
          </div>
        </div>

        <div class="no-results" *ngIf="filteredMechanics.length === 0 && !isLoading">
          <i class="fas fa-search"></i>
          <p>Nenhum mecânico encontrado</p>
        </div>
      </div>
    </div>

    <!-- Pagination -->
    <div class="modal-pagination" *ngIf="!isLoading && totalPages > 1">
      <div class="pagination-info">
        <span>Mostrando {{ (currentPage - 1) * pageSize + 1 }} - {{ Math.min(currentPage * pageSize, totalCount) }} de {{ totalCount }} funcionários</span>
      </div>
      <div class="pagination-controls">
        <button 
          class="btn-pagination" 
          (click)="previousPage()" 
          [disabled]="currentPage === 1"
          type="button">
          <i class="fas fa-chevron-left"></i>
        </button>
        
        <button 
          *ngIf="getPageNumbers()[0] > 1"
          class="btn-pagination" 
          (click)="goToPage(1)"
          type="button">
          1
        </button>
        
        <span *ngIf="getPageNumbers()[0] > 2" class="pagination-ellipsis">...</span>
        
        <button 
          *ngFor="let page of getPageNumbers()"
          class="btn-pagination" 
          [class.active]="page === currentPage"
          (click)="goToPage(page)"
          type="button">
          {{ page }}
        </button>
        
        <span *ngIf="getPageNumbers()[getPageNumbers().length - 1] < totalPages - 1" class="pagination-ellipsis">...</span>
        
        <button 
          *ngIf="getPageNumbers()[getPageNumbers().length - 1] < totalPages"
          class="btn-pagination" 
          (click)="goToPage(totalPages)"
          type="button">
          {{ totalPages }}
        </button>
        
        <button 
          class="btn-pagination" 
          (click)="nextPage()" 
          [disabled]="currentPage === totalPages"
          type="button">
          <i class="fas fa-chevron-right"></i>
        </button>
      </div>
    </div>

    <!-- Footer -->
    <div class="modal-footer">
      <button class="btn btn-secondary" (click)="close()" type="button">
        <i class="fas fa-times"></i>
        Cancelar
      </button>
      <button 
        class="btn btn-primary" 
        (click)="confirmSelection()" 
        type="button"
        [disabled]="!selectedMechanic">
        <i class="fas fa-check"></i>
        Selecionar
      </button>
    </div>
  </div>
</div>
